import { render } from "./DragTable.vue?vue&type=template&id=d16de0da"
import script from "./DragTable.vue?vue&type=script&lang=js"
export * from "./DragTable.vue?vue&type=script&lang=js"

import "./DragTable.vue?vue&type=style&index=0&id=d16de0da&lang=scss"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__